export var source = "query ProductTags($productId: String!) {\n  product(slug: $productId) {\n    tagTypes {\n      type\n      tags {\n        id\n        name\n        image\n      }\n    }\n  }\n}";
export default source;